// extracted by mini-css-extract-plugin
export var modal = "_d4-0";